import AddPath from "csi/def/AddPath";
import { Context } from "csi/def/Context";
import Relationship from "csi/def/Relationship";
import MultiSelectSwitchboard from "csi/toolbar/MultiSelectSwitchboard";
import { C8Node } from "csi/typings";
import { ViewWidget } from "csi/view/Widget";
import Query from "csi/xml/Query";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
import _ from "lodash";

const SelectAffectedItemsSwitchboard = declare(MultiSelectSwitchboard, {
	disableButtonAction: true,
	idViewProperty: "selectedAffectedItems",
	refreshStoreOptions: true,
	resDefault: "SelectAll",
	switchboardPath: "Child:AffectedItems",

	/**
	 * @override
	 * return true if there is at least one AffectedItem
	 */
	canShowPlugin(): boolean {
		const engineeringChangeNode = this.getView().getViewNode();
		const affectedItemsUrls = engineeringChangeNode?.AffectedItems;
		return !_.isEmpty(affectedItemsUrls);
	},

	/**
	 * @override
	 * Do nothing - idViewProperty handles it all
	 */
	onChangeItem(view: ViewWidget, node: C8Node): void {
	},

	/**
	 * @override
	 * Overrided creation of relationship in order to add an extra filter
	 */
	_getStoreOptions(url: string, rel) {
		rel = lang.mixin(new Relationship(), {
			m_url: url,
			m_addPaths: [lang.mixin(new AddPath(), {
				m_path: this.switchboardPath,
			})],
			m_query: new Query(),
		});

		return this.inherited(arguments);
	},

	/**
	 * @override
	 * Hide if printing
	 */
	validatePlugin(ctx: Context): boolean {
		return !ctx.bPrint;
	},
});

export = SelectAffectedItemsSwitchboard;